import {Component, Input, ViewEncapsulation} from '@angular/core';
import {BeschreibendeStatistik} from 'shared/dtos/cockpit-kontrolle/pruefung-der-variablen';

@Component({
  selector: '[appPruefungDerVariablenTableRow]',
  templateUrl: './pruefung-der-variablen-table-row.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PruefungDerVariablenTableRowComponent {
  @Input() rowdata: BeschreibendeStatistik;
  @Input() rowHeader: string;
  @Input() crtLocale: string;
  @Input() minFractioningDigits: number;
}
